import { observer } from 'mobx-react';
import { FormTemplate } from '../../../../../../../../../../../Resource/FormTemplates/Types';
import { LearningCollectionPublishResource } from '../../../../Store/Types';
import InviteParticipantStore from '../Store';
import InviteModal from './InviteModal';
import ParticipantsInvitedModal from './ParticipantsInvitedModal';
import SelectParticipantsModal from './SelectParticipantsModal';

interface Props {
  store: InviteParticipantStore;
  learningCollectionPublishResource: LearningCollectionPublishResource;
  template: FormTemplate;
}

function ModalSwitcher({ store, learningCollectionPublishResource, template }: Props) {
  switch (store.state.kind) {
    case 'ready':
    case 'new-participant':
    case 'new-group':
    case 'remove-participant':
    case 'remove-group':
    case 'error':
    case 'get-license-information':
      return (
        <SelectParticipantsModal
          state={store.state}
          store={store}
          learningCollectionPublishResource={learningCollectionPublishResource}
        />
      );
    case 'participants-invited':
      return (
        <ParticipantsInvitedModal
          store={store}
          successfulCommunicationsCount={store.state.successfulCommunicationsCount}
          sendEmailDate={store.state.sendEmailDate}
          skipCommunications={store.state.skipCommunications}
        />
      );
    case 'submitting':
    case 'inviting':
      return (
        <InviteModal
          store={store}
          template={template}
          timeZone={store.state.timeZone}
          skipCommunications={store.state.skipCommunications}
        />
      );
  }
}

export default observer(ModalSwitcher);
